export default __webpack_public_path__ + "static/media/porshce.be5eeea5.svg";